import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputColorModel } from '@blaze-shared/elements-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const barcodeScannerV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate accent from general.accent to input.accent',
  run: (props: PartialPropsOf<'barcodeScanner'>): void => {
    if (!props.style?.general || !props.style.input) {
      return;
    }
    if ('accent' in props.style.general && props?.style?.general.accent) {
      props.style.input.accent = {
        ...props.style.general.accent,
      } as PropertiesConfigInputColorModel;
      delete props.style.general.accent;
    }
  },
};
